import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../lib/api";
import { getUser, saveSession } from "../../lib/auth";
import { PasswordInput } from "../../components/ui/password-input";
import { Button } from "../../components/ui/button";
import { Label } from "../../components/ui/label";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";

export default function AdminForceChangePassword() {
  const nav = useNavigate();
  const user = getUser();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirmVal, setConfirmVal] = useState("");
  const [saving, setSaving] = useState(false);

  async function submit(e) {
    e.preventDefault();
    if (next.length < 8) { toast.error("A nova senha deve ter no mínimo 8 caracteres"); return; }
    if (next !== confirmVal) { toast.error("A confirmação não corresponde à nova senha"); return; }
    setSaving(true);
    try {
      await api.post("/auth/change-password", { current_password: current, new_password: next });
      if (user) saveSession(localStorage.getItem("azu_token"), { ...user, must_change_password: false });
      toast.success("Senha atualizada");
      nav("/admin");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Erro");
    } finally {
      setSaving(false);
    }
  }

  return (
    <div className="min-h-screen bg-[#22302E] text-white flex items-center justify-center px-6 font-admin" data-testid="force-change-page">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-[#0AA89C]">
            <KeyRound className="w-6 h-6 text-white" />
          </div>
          <h1 className="font-display text-3xl mt-4">Defina uma nova senha</h1>
          <p className="text-white/70 text-sm mt-2">A senha inicial é compartilhada entre os quatro perfis administrativos. Antes de continuar, cadastre uma senha pessoal.</p>
        </div>
        <form onSubmit={submit} className="bg-white text-[#22302E] rounded-md p-8" data-testid="force-change-form">
          <div className="space-y-4">
            <div>
              <Label htmlFor="fc-current">Senha atual (compartilhada)</Label>
              <PasswordInput id="fc-current" value={current} onChange={(e) => setCurrent(e.target.value)} required data-testid="fc-current" autoComplete="current-password" />
            </div>
            <div>
              <Label htmlFor="fc-new">Nova senha (mín. 8 caracteres)</Label>
              <PasswordInput id="fc-new" value={next} onChange={(e) => setNext(e.target.value)} required minLength={8} data-testid="fc-new" autoComplete="new-password" />
            </div>
            <div>
              <Label htmlFor="fc-confirm">Confirme a nova senha</Label>
              <PasswordInput id="fc-confirm" value={confirmVal} onChange={(e) => setConfirmVal(e.target.value)} required data-testid="fc-confirm" autoComplete="new-password" />
            </div>
          </div>
          <Button type="submit" disabled={saving} className="w-full mt-6 bg-[#0AA89C] hover:bg-[#066B63] text-white" data-testid="fc-submit">
            {saving ? "Salvando..." : "Salvar e continuar"}
          </Button>
        </form>
      </div>
    </div>
  );
}
